import useDescriptionTitle from '../hooks/useDescriptionTitle';
import LayoutAvaliacoes from 'components/Utilities/LayoutAvaliacoes';

const Avaliacoes: React.FC = () => {
  useDescriptionTitle('Historico', 'Avaliações');
  return <LayoutAvaliacoes title="Avaliações" />;
};

export default Avaliacoes;
